import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "../components/RegisteredAnimalsForm";
import AnimalTab from "../components/AnimalTab";
import Card from "components/card";
import { ANIMAL_TYPE_CARABAO } from "variables/constants";

const ViewCarabao = () => {
	const { carabaoId } = useParams();

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<RegisteredAnimalsForm recordId={carabaoId} mode="view" animalTypeId={ANIMAL_TYPE_CARABAO}/>

				<div className="mt-4 mb-4">
					<Card extra={"w-full h-full p-4"}>
						<AnimalTab recordId={carabaoId}/>
					</Card>
				</div>
	      </div>
	    </div>
    );
};

export default ViewCarabao;